module.exports = __webpack_public_path__ + "img/PP-Box-Coin-V9 1.58d000f2.png";